// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"80":"6bb8cdc8","205":"d1c06f6f","622":"59fac68e","695":"d6593f12","770":"e9c73d86","825":"7a855ad7"}[chunkId] + ".css";
};